import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import theme from './theme'
import './App.css'
import Regisform from './containers/Regisform'
import RegisFirstPage from './containers/RegisFirstPage'
import Thankyou from './containers/Thankyou'
import TermAndCondition from './containers/TermAndCondition'
import Event from './containers/Event'
import Reject from './containers/Reject'

function App() {
  const urlParams = new URLSearchParams(window.location.search)
  const qrCode = urlParams.get('qrcode')
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Routes>
          <Route exact path="/" element={<Regisform />} />
          {/* <Route path="information" element={<Regisform qrCode={qrCode} />} /> */}
          <Route path="thankyou" element={<Thankyou qrCode={qrCode} />} />
          <Route path="login" element={<RegisFirstPage />} />
          <Route path="event" element={<Event qrCode={qrCode} />} />
          <Route path="reject" element={<Reject />} />
          <Route path="terms-conditions" element={<TermAndCondition />} />
          <Route
            path="*"
            element={
              <div>
                <h2>404 Page not found</h2>
              </div>
            }
          />
        </Routes>
      </div>
    </ThemeProvider>
  )
}

export default App
